import React from 'react';
import { Link } from '@reach/router';
import Testimony from '../components/carouseltestimony';
import Footer from '../components/footer';
import ImageGallery from "../components/ImageGallery";


export default () => (
<div className='wraperitem'>
  <style>
    {`
      .about-heading-responsive {
        font-size: 2.5rem !important;
        line-height: 1.3;
        position: relative;
        padding: 20px 25px;
      }
      /* Tüm ekranlarda dekoratif köşe süslemeleri */
      .about-heading-responsive::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 50px;
        height: 50px;
        border-top: 3px solid #d4af37;
        border-left: 3px solid #d4af37;
        opacity: 0.8;
      }
      .about-heading-responsive::after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 50px;
        height: 50px;
        border-bottom: 3px solid #d4af37;
        border-right: 3px solid #d4af37;
        opacity: 0.8;
      }
      /* Mobilde dekoratif köşe süslemeleri */
      @media (max-width: 768px) {
        .about-heading-responsive {
          font-size: 2rem !important;
          line-height: 1.4;
          padding: 15px 20px;
        }
        .about-heading-responsive::before {
          width: 40px;
          height: 40px;
          border-top: 3px solid #d4af37;
          border-left: 3px solid #d4af37;
        }
        .about-heading-responsive::after {
          width: 40px;
          height: 40px;
          border-bottom: 3px solid #d4af37;
          border-right: 3px solid #d4af37;
        }
      }
      @media (max-width: 480px) {
        .about-heading-responsive {
          font-size: 1.8rem !important;
          line-height: 1.3;
          padding: 12px 15px;
        }
        .about-heading-responsive::before {
          width: 30px;
          height: 30px;
          border-top: 2px solid #d4af37;
          border-left: 2px solid #d4af37;
        }
        .about-heading-responsive::after {
          width: 30px;
          height: 30px;
          border-bottom: 2px solid #d4af37;
          border-right: 2px solid #d4af37;
        }
      }
      /* Mobilde sıralama: Güvenlik yazısı Misyonumuz'un üstünde */
      .misyon-section {
        display: flex;
        flex-wrap: wrap;
      }
      .misyon-yazi {
        order: 2;
      }
      .guvenlik-baslik {
        order: 1;
      }
      @media (min-width: 769px) {
        .misyon-yazi {
          order: 1;
        }
        .guvenlik-baslik {
          order: 2;
        }
      }
    `}
  </style>
  <section className='jumbotron breadcumb' style={{backgroundImage: `url(${'./img/hero.png'})`}}>
    <div className='mainbreadcumb'>
      <div className='container-fluid'>
        <div className='row m-10-hor'>
          <div className='col-md-6'>
            <h1>Hakkımızda</h1>
          </div>
          <div className='col-md-6'>
            <div className='list'>
              <Link className='link' to="/home1">Anasayfa</Link>
              <span className='dash'>/</span>
              <span>Hakkımızda</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section className='container-fluid black_more'>
        <div className='row m-10-hor'>

          <div className='col-md-5'>
            <div className='heading about-heading-responsive'>
              Karton kutu<span className='br'></span> Ambalaj <span className='br'></span> Seperatör
            </div>
          </div>

          <div className='col-md-7'>
            <h2>Vizyonumuz </h2>
            <div className='content'>
              
              Han Grup Ltd. Şti. olarak vizyonumuz; güvenlik teknolojileri alanında 
              yenilikçi, güvenilir ve sürdürülebilir çözümler sunarak sektörün lider 
              markalarından biri olmaktır. Kamera güvenlik sistemleri, alarm çözümleri ve yangın 
              söndürme teknolojilerinde en ileri teknolojiyi müşterilerimizle buluşturarak, hem bireylerin
               hem kurumların güvenliğini en üst düzeye taşımayı hedefliyoruz. Güvenlikte kalite, teknoloji
                ve profesyonellik denildiğinde ilk akla gelen şirket olmak için sürekli gelişmeyi benimsiyoruz.
            </div>
          </div>
        </div>
  </section>
    <section className='container-fluid black_more'>
        <div className='row m-10-hor misyon-section'>

          <div className='col-md-7 misyon-yazi'>
            <h2>Misyonumuz </h2>
            <div className='content'>
              Han Grup Ltd. Şti. olarak misyonumuz; müşterilerimize yüksek standartlarda,
               etkin ve uzun ömürlü güvenlik çözümleri sunmaktır. Kamera güvenlik ve alarm 
               sistemlerinden yangın algılama ve söndürme çözümlerine kadar tüm hizmetlerimizde 
               güvenilirlik, kalite ve hızlı hizmet anlayışını esas alıyoruz. İnsan hayatını, iş yerlerini
                ve değerleri korumak için teknolojiyi doğru şekilde kullanarak, her ölçekte projeye profesyonel
                 çözümler üretmeyi ve güvenlikte sürdürülebilir bir fark oluşturmayı amaçlıyoruz.
            </div>
          </div>
          <div className='col-md-5 guvenlik-baslik'>
            <div className='heading about-heading-responsive'>
              Güvenlik Sistemleri<span className='br'></span>Alarm Çözümleri <span className='br'></span>Yangın Söndürme 
            </div>
          </div>

        </div>
  </section>

  <section className='container-fluid black_more'>
    <div className='row m-10-hor'>
      <div className='col-12'>
        <div className='AppContainer'>
          <ImageGallery />
        </div>
      </div>
    
    </div>
  </section>

  <Testimony />
  <Footer />
</div>

);